import { applyDynamicTheme, clearDynamicTheme } from "./dynamicTheme";

// Vuex plugin: reapply/clear the dynamic-theme override whenever the client
// branding state changes. Covers all sign-in paths and the persisted-state
// rehydration that happens on app load. Clients that supply a base_hex still
// report skin === 0 — the dynamic template is rendered in that case.
export default function dynamicThemePlugin(store) {
  const sync = client => {
    if (!client) return clearDynamicTheme();
    if (client.skin === 0 && client.base_hex) {
      applyDynamicTheme(client.base_hex);
    } else {
      clearDynamicTheme();
    }
  };
  sync(store.state.client);
  store.subscribe((mutation, state) => {
    if (mutation.type === "setClientBranding" || mutation.type === "setSkin") {
      sync(state.client);
    }
  });
}
